var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { height: "93vh", width: "100%" },
      attrs: { id: "gps-map" },
    },
    [
      _c(
        "l-map",
        {
          ref: "mapRef",
          staticStyle: { "z-index": "10" },
          attrs: {
            "world-copy-jump": true,
            zoom: _vm.zoom,
            "min-zoom": 3,
            center: _vm.center,
            bounds: _vm.computedBounds,
          },
          on: {
            "update:zoom": _vm.zoomUpdated,
            "update:center": _vm.centerUpdated,
            "update:bounds": _vm.boundsUpdated,
          },
        },
        [
          _c("l-tile-layer", { attrs: { url: _vm.url } }),
          _c(
            "l-control",
            { attrs: { position: "bottomright" } },
            [
              _c("map-legend", {
                staticClass: "box is-hidden-touch",
                attrs: { id: "legend" },
              }),
            ],
            1
          ),
          _c(
            "l-marker-cluster",
            { attrs: { options: _vm.clusterOptions } },
            _vm._l(_vm.markers, function (marker) {
              return _c(
                "l-marker",
                {
                  key: marker.mapMarker.id,
                  attrs: {
                    "lat-lng": marker.mapMarker.getLatLng(),
                    icon: marker.mapMarker.getIcon(),
                  },
                  on: { mouseover: marker.hoverEvent },
                },
                [
                  _c("l-tooltip", { attrs: { options: { sticky: true } } }, [
                    _c("b", [_vm._v(_vm._s(marker.name))]),
                    _c("br"),
                    _vm._v(_vm._s(marker.city) + " "),
                    _c("br"),
                    _vm._v(_vm._s(marker.country) + " "),
                  ]),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }